// extracted by mini-css-extract-plugin
export default {"modalHeader":"kJO9a8VXs3C5PRDpA0xh__modalHeader___"};